<section class="event-form-page">
  <header class="form-header">
    <a class="back-link" routerLink="/dashboard/events">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>
      <span>К событиям</span>
    </a>
    <h1>{{ title }}</h1>
  </header>

  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <form class="event-form" (ngSubmit)="saveEvent()" *ngIf="!loading; else loadingState">
    <section class="form-card">
      <h2>Матч</h2>

      <div class="form-grid">
        <label>
          <span>Дата события</span>
          <input class="form-control" type="date" name="startsAt" [(ngModel)]="formData.startsAt" required>
        </label>

        <label>
          <span>Статус события</span>
          <select class="form-select" name="status" [(ngModel)]="formData.status">
            <option value="planned">Планируется</option>
            <option value="in_progress">В работе</option>
            <option value="completed">Завершен</option>
          </select>
        </label>

        <label>
          <span>Чемпионат</span>
          <select class="form-select" name="championshipId" [(ngModel)]="formData.championshipId" (ngModelChange)="onChampionshipChange()" required>
            <option value="">Выберите чемпионат</option>
            <option *ngFor="let championship of championships; trackBy: trackById" [value]="championship.id">{{ championship.name }}</option>
          </select>
        </label>

        <label>
          <span>Домашняя команда</span>
          <select class="form-select" name="homeTeamId" [(ngModel)]="formData.homeTeamId" (ngModelChange)="onHomeTeamChange()" [disabled]="!formData.championshipId" required>
            <option value="">Выберите команду</option>
            <option *ngFor="let team of availableHomeTeams; trackBy: trackById" [value]="team.id">{{ team.name }}</option>
          </select>
        </label>

        <label>
          <span>Гостевая команда</span>
          <select class="form-select" name="awayTeamId" [(ngModel)]="formData.awayTeamId" (ngModelChange)="onAwayTeamChange()" [disabled]="!formData.championshipId" required>
            <option value="">Выберите команду</option>
            <option *ngFor="let team of availableAwayTeams; trackBy: trackById" [value]="team.id">{{ team.name }}</option>
          </select>
        </label>

        <label>
          <span>Сезон</span>
          <select class="form-select" name="seasonId" [(ngModel)]="formData.seasonId" (ngModelChange)="onSeasonChange()" [disabled]="!formData.championshipId" required>
            <option value="">{{ formData.championshipId ? 'Выберите сезон' : 'Сначала выберите чемпионат' }}</option>
            <option *ngFor="let season of availableSeasons; trackBy: trackById" [value]="season.id">{{ season.name }}{{ season.isCurrent ? ' · активный' : '' }}</option>
          </select>
        </label>

        <ng-container *ngIf="usesSplitSeasonPhasePicker; else singlePhasePicker">
          <label>
            <span>Раздел сезона</span>
            <select class="form-select" name="seasonPhaseMode" [(ngModel)]="seasonPhaseMode" (ngModelChange)="onSeasonPhaseModeChange()" [disabled]="!formData.seasonId" required>
              <option value="regular">Регулярный сезон</option>
              <option value="playoff" [disabled]="playoffStagePhases.length === 0">Плей-офф</option>
            </select>
          </label>

          <label *ngIf="seasonPhaseMode === 'playoff'">
            <span>Стадия плей-офф</span>
            <select class="form-select" name="seasonPhaseId" [(ngModel)]="formData.seasonPhaseId" (ngModelChange)="onPlayoffStageChange()" [disabled]="!formData.seasonId || playoffStagePhases.length === 0" required>
              <option value="">{{ playoffStagePhases.length ? 'Выберите стадию' : 'Стадии не добавлены' }}</option>
              <option *ngFor="let phase of playoffStagePhases; trackBy: trackById" [value]="phase.id">{{ phase.name }}</option>
            </select>
          </label>
        </ng-container>

        <ng-template #singlePhasePicker>
          <label>
            <span>Фаза сезона</span>
            <select class="form-select" name="seasonPhaseId" [(ngModel)]="formData.seasonPhaseId" [disabled]="!formData.seasonId" required>
              <option value="">{{ formData.seasonId ? 'Выберите фазу' : 'Сначала выберите сезон' }}</option>
              <option *ngFor="let phase of availablePhases; trackBy: trackById" [value]="phase.id">{{ getPhaseName(phase) }}</option>
            </select>
          </label>
        </ng-template>
      </div>
    </section>

    <section class="form-card participants-card">
      <div class="card-heading">
        <div>
          <h2>Участники взаиморасчетов</h2>
          <span>Доли распределяются автоматически. Остаток при делении получает IVA52.</span>
        </div>
        <strong class="share-total" [class.invalid]="participantShareTotal !== 10000">Итого: {{ formatShare(participantShareTotal) }}%</strong>
      </div>

      <div class="participant-list" *ngIf="participantDrafts.length > 0; else emptyParticipants">
        <article class="participant-row" *ngFor="let participant of participantDrafts">
          <div>
            <strong>{{ getParticipantName(participant.userId) }}</strong>
            <span>Доля в прибыли</span>
          </div>
          <b>{{ formatShare(participant.profitShareBasisPoints) }}%</b>
          <button class="remove-button" type="button" title="Удалить участника" aria-label="Удалить участника" (click)="removeParticipant(participant.userId)">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
          </button>
        </article>
      </div>

      <ng-template #emptyParticipants>
        <div class="empty-note">Добавьте хотя бы одного участника события.</div>
      </ng-template>

      <div class="participant-add">
        <select class="form-select" name="selectedParticipantUserId" [(ngModel)]="selectedParticipantUserId">
          <option value="">Выберите пользователя</option>
          <option *ngFor="let user of availableParticipantUsers; trackBy: trackById" [value]="user.id">{{ user.displayName || user.username }}</option>
        </select>
        <button class="ghost-link" type="button" [disabled]="!selectedParticipantUserId" (click)="addParticipant()">Добавить</button>
      </div>
    </section>

    <section class="form-card actions-card">
      <button class="save-button" type="submit" [disabled]="!canSaveEvent">{{ saving ? 'Сохраняем...' : 'Сохранить' }}</button>
      <a class="ghost-link" routerLink="/dashboard/events">Отмена</a>
      <p class="empty-note" *ngIf="!canSaveEvent && !saving">Для события выберите дату, чемпионат, сезон, фазу, две разные команды и участников взаиморасчетов.</p>
    </section>
  </form>

  <ng-template #loadingState>
    <div class="form-card loading-card">Загрузка события...</div>
  </ng-template>
</section>
